import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtListRow from "../../components/NtListRow";
import NtBadge from "../../components/NtBadge";
import NtMaterialIcon from "../../components/NtMaterialIcon";
import NtTouchableEffect from "../../components/NtTouchableEffect";
import { useTheme } from "../../context/ThemeContext";

function NtUserItem({ item, columns, active, onPress }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <NtTouchableEffect
      style={active ? styles.active : styles.row}
      onPress={onPress}
    >
      <NtListRow
        item={item}
        columns={columns}
        renderCustom={(row, column) => {
          if (column === "name") {
            return row?.contact?.contact_name_given;
          } else if (column === "user_enabled") {
            const enabled = row[column] == "true";
            return (
              <NtBadge variant={enabled ? "green" : "gray"}>
                {enabled ? "Enabled" : "Disabled"}
              </NtBadge>
            );
          }
        }}
        renderAction={
          <View style={styles.chev}>
            <NtMaterialIcon
              name="chevron-right"
              color={active ? theme.brand2 : theme.textDim}
              size={18}
            />
          </View>
        }
      />
    </NtTouchableEffect>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    row: { cursor: "pointer" },
    active: {
      backgroundColor: t.pillBg,
      borderLeftWidth: 2,
      borderLeftColor: t.brand2,
      cursor: "pointer",
    },
    chev: {
      width: 28,
      alignItems: "center",
      justifyContent: "center",
    },
  });

export default NtUserItem;
